export default "__VITE_ASSET__Uy3IxJ6B__"